import { createContext } from "react";

import { FlowContextValue } from "./FlowContext.types";

import { FlowTypes } from "@enums";

export const FlowContext = createContext<FlowContextValue>(FlowTypes.Generic);
